/**
 * The ProgressModule is a Vuex module that is used to keep track of the
 * status of a bulk action. It exposes actions that increment the progress
 * of the action and getters to retrieve the current progress.
 */
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    counter: {
      completed: 0,
      total: 0,
    },
    bulkActionInProgress: false,
  },

  actions: {
    incrementCompleted(context = { state: { counter: {} } }) {
      const { completed } = context.state.counter;
      context.commit('SET_COUNTER', {
        completed: completed + 1,
      });
    },

    setCounter({ commit }, counter) {
      commit('SET_COUNTER', counter);
    },

    updateBulkActionStatus({ commit }, inProgress = true) {
      commit('SET_BULK_ACTION_IN_PROGRESS', inProgress);
    },
  },

  getters: {
    getCounter(state = { counter: 0 }) {
      return state.counter;
    },

    isBulkTaskInProgress: state => state.bulkActionInProgress,

    getRemainingCount(state) {
      const { completed, total } = state.counter;
      return total - completed;
    },
  },

  mutations: {
    SET_COUNTER(state = { counter: {} }, counter = {}) {
      if (typeof counter.completed !== 'undefined') {
        Vue.set(state.counter, 'completed', counter.completed);
      }
      if (typeof counter.total !== 'undefined') {
        Vue.set(state.counter, 'total', counter.total);
      }
    },

    SET_BULK_ACTION_IN_PROGRESS(state, status = true) {
      Vue.set(state, 'bulkActionInProgress', status);
    },
  },
};
